export default "__VITE_ASSET__3hvmH$vf__"